var map = {
	"./English/Feeling the positives.mp3": [
		227,
		3
	],
	"./English/Giving and taking meditation.mp3": [
		228,
		4
	],
	"./English/Loving kindness meditation.mp3": [
		229,
		5
	],
	"./English/Self compassion break.mp3": [
		230,
		6
	],
	"./English/Soothing breathing rhythm.mp3": [
		231,
		7
	],
	"./English/Stop and be present.mp3": [
		232,
		8
	],
	"./English/Stop and breath with a difficult situation.mp3": [
		233,
		9
	],
	"./English/Watching Thoughts.mp3": [
		234,
		10
	],
	"./German/Feeling the positives.mp3": [
		235,
		11
	],
	"./German/Giving and taking meditation.mp3": [
		236,
		12
	],
	"./German/Loving kindness meditation.mp3": [
		237,
		13
	],
	"./German/Self compassion break.mp3": [
		238,
		14
	],
	"./German/Soothing breathing rhythm.mp3": [
		239,
		15
	],
	"./German/Stop and be present.mp3": [
		240,
		16
	],
	"./German/Stop and breath with a difficult situation.mp3": [
		241,
		17
	],
	"./German/Watching Thoughts.mp3": [
		242,
		18
	],
	"./Portuguese/F/Feeling the positives.mp3": [
		243,
		19
	],
	"./Portuguese/F/Giving and taking meditation.mp3": [
		244,
		20
	],
	"./Portuguese/F/Loving kindness meditation.mp3": [
		245,
		21
	],
	"./Portuguese/F/Self compassion break.mp3": [
		246,
		22
	],
	"./Portuguese/F/Soothing breathing rhythm.mp3": [
		247,
		23
	],
	"./Portuguese/F/Stop and be present.mp3": [
		248,
		24
	],
	"./Portuguese/F/Stop and breath with a difficult situation.mp3": [
		249,
		25
	],
	"./Portuguese/F/Watching Thoughts.mp3": [
		250,
		26
	],
	"./Portuguese/M/Feeling the positives.mp3": [
		251,
		27
	],
	"./Portuguese/M/Giving and taking meditation.mp3": [
		252,
		28
	],
	"./Portuguese/M/Loving kindness meditation.mp3": [
		253,
		29
	],
	"./Portuguese/M/Self compassion break.mp3": [
		254,
		30
	],
	"./Portuguese/M/Soothing breathing rhythm.mp3": [
		255,
		31
	],
	"./Portuguese/M/Stop and be present.mp3": [
		256,
		32
	],
	"./Portuguese/M/Stop and breath with a difficult situation.mp3": [
		257,
		33
	],
	"./Portuguese/M/Watching Thoughts.mp3": [
		258,
		34
	],
	"./Spanish (Europe)/Feeling the positives.mp3": [
		259,
		35
	],
	"./Spanish (Europe)/Giving and taking meditation.mp3": [
		260,
		36
	],
	"./Spanish (Europe)/Loving kindness meditation.mp3": [
		261,
		37
	],
	"./Spanish (Europe)/Self compassion break.mp3": [
		262,
		38
	],
	"./Spanish (Europe)/Soothing breathing rhythm.mp3": [
		263,
		39
	],
	"./Spanish (Europe)/Stop and be present.mp3": [
		264,
		40
	],
	"./Spanish (Europe)/Stop and breath with a difficult situation.mp3": [
		265,
		41
	],
	"./Spanish (Europe)/Watching Thoughts.mp3": [
		266,
		42
	],
	"./Spanish (Latin America)/Feeling the positives.mp3": [
		267,
		43
	],
	"./Spanish (Latin America)/Giving and taking meditation.mp3": [
		268,
		44
	],
	"./Spanish (Latin America)/Loving kindness meditation.mp3": [
		269,
		45
	],
	"./Spanish (Latin America)/Self compassion break.mp3": [
		270,
		46
	],
	"./Spanish (Latin America)/Soothing breathing rhythm.mp3": [
		271,
		47
	],
	"./Spanish (Latin America)/Stop and be present.mp3": [
		272,
		48
	],
	"./Spanish (Latin America)/Stop and breath with a difficult situation.mp3": [
		273,
		49
	],
	"./Spanish (Latin America)/Watching Thoughts.mp3": [
		274,
		50
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 192;
module.exports = webpackAsyncContext;